// @flow
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export default graphql(
  gql`
    mutation signup(
      $firstName: String!
      $lastName: String!
      $password: String!
      $email: String!
    ) {
      registerNewUser(
        firstName: $firstName
        lastName: $lastName
        password: $password
        email: $email
      ) {
        id
      }
    }
  `,
  {
    name: 'signup',
  }
);



// WEBPACK FOOTER //
// ./src/pages/sign-up/graphql.js